const toBoolean = (val) =>
  val === true || val === 1 || val === '1';

export const normalizeIjin = (item) => ({
  ...item,

  telat: toBoolean(item.telat),

  periode: item.periode || '-',
  nama_pengganti: item.nama_pengganti || '-',
  nama: item.nama || '-',
});